import {Role} from './role.enum';

export class RoleGroup {
  static readonly CUSTOMER = [
    Role.CUSTOMER_ADMIN,
    Role.CUSTOMER_USER
  ] as const;

  static readonly INTERNAL = [
    Role.LIMITED,
    Role.STANDARD,
    Role.ADMIN
  ] as const;

  static isCustomerRole(role: Role): boolean {
    return this.CUSTOMER.includes(role as any);
  }

  static isCustomerRoleString(role: string): boolean {
    return this.CUSTOMER.includes(role as any);
  }

  static isInternalRole(role: Role): boolean {
    return this.INTERNAL.includes(role as any);
  }

  static isInternalRoleString(role: string): boolean {
    return this.INTERNAL.includes(role as any);
  }

  static getAllRoles(): Role[] {
    return [...this.CUSTOMER, ...this.INTERNAL];
  }
}

